import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex no-wrap column h-full" }
const _hoisted_2 = { class: "px-5 pt-4 pb-7 border-b" }
const _hoisted_3 = { class: "mb-4 py-2px" }
const _hoisted_4 = { class: "space-y-4 mt-3" }

import SignOut from '@/components/drawer/SignOut.vue'
import ChangeEnvironment from '@/components/drawer/ChangeEnvironment.vue'
import SelectLanguage from '@/components/drawer/SelectLanguage.vue'
import { useMainStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mainStore = useMainStore()


return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_c_expansion_item = _resolveComponent("c-expansion-item")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_c_drawer = _resolveComponent("c-drawer")!

  return (_openBlock(), _createBlock(_component_c_drawer, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(mainStore).userDisplayName), 1),
          _createVNode(ChangeEnvironment, {
            onClick: _unref(mainStore).changeEnvironment
          }, null, 8, ["onClick"])
        ]),
        _createVNode(_component_c_expansion_item, {
          label: _ctx.$t('user.heading')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_q_input, _mergeProps({
                        modelValue: _unref(mainStore).user.userName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(mainStore).user.userName) = $event))
                      }, _ctx.$inri.inputDense, {
                        readonly: "",
                        label: _ctx.$t('user.username')
                      }), null, 16, ["modelValue", "label"]),
                      _createVNode(_component_q_input, _mergeProps({
                        modelValue: _unref(mainStore).user.firstName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(mainStore).user.firstName) = $event))
                      }, _ctx.$inri.inputDense, {
                        readonly: "",
                        label: _ctx.$t('user.first_name')
                      }), null, 16, ["modelValue", "label"]),
                      _createVNode(_component_q_input, _mergeProps({
                        modelValue: _unref(mainStore).user.lastName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(mainStore).user.lastName) = $event))
                      }, _ctx.$inri.inputDense, {
                        readonly: "",
                        label: _ctx.$t('user.last_name')
                      }), null, 16, ["modelValue", "label"])
                    ]),
                    _createVNode(SelectLanguage)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_q_space),
        _createVNode(SignOut, {
          onClick: _unref(mainStore).signOut
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}
}

})